export default "__VITE_ASSET__Cpm8HptK__"